import { FC } from 'react'
import { CustomModal } from '../../../../../../components/customModal'
import { AddToProjectForm } from '../../../AddToProjectForm'
import { TechnologiesActions } from '../../../../../../store/technologies'
import { SnackbarActions } from '../../../../../../store/snackbar'
import { AppDispatch } from '../../../../../../store'
import { useDispatch } from 'react-redux'

interface AddToProjectModalProps {
  open: boolean
  setOpen: Function
  itemToAdd: string
}

export const AddToProjectModal: FC<AddToProjectModalProps> = ({ open, itemToAdd ,setOpen }) => {
  const dispatch = useDispatch<AppDispatch>()

  const handleAddToProject = async (selectedProject:string) => {
    const resultAction = await dispatch(
      TechnologiesActions.createTechnologyPFAsync({
        techId: selectedProject,
        body: { einNumber: itemToAdd },
      }),
    )

    if (TechnologiesActions.createTechnologyPFAsync.fulfilled.match(resultAction)) {
      dispatch(
        SnackbarActions.showSnackbar({
          message: 'PF added to project successfully!',
          options: { variant: 'success' },
        }),
      )

      setOpen(false)
    }
  }

  return (
    <CustomModal
      open={open}
      setOpen={setOpen}
      title="Add to project"
      closeButtonAction={() => setOpen(false)}
    >
      <AddToProjectForm handleAddToProject={handleAddToProject} showModal={setOpen} />
    </CustomModal>
  )
}
